
import * as xenosRuntime$BFOp9n0hwt from '/app/image-providers/xenos.ts'
import * as ipxRuntime$YsWfzECyTQ from '/app/node_modules/.pnpm/@nuxt+image@1.8.1_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "mobile": 460,
    "tablet": 740,
    "laptop": 1080,
    "desktop": 1600,
    "tv": 1920
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "charon.justchunks.net",
    "dunb17ur4ymx4.cloudfront.net"
  ],
  "alias": {
    "/charon": "https://charon.justchunks.net/v1/file-references/file"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['xenos']: { provider: xenosRuntime$BFOp9n0hwt, defaults: {"baseURL":"https://charon.justchunks.net/v1/users/"} },
  ['ipx']: { provider: ipxRuntime$YsWfzECyTQ, defaults: {} }
}
        